export enum DIFFICULTY_STATUS{
    EASY = 1,
    HARD = 3
}